<script setup>
import NavigateBack from '@/components/shared/NavigateBack.vue'
import PdfPreviewPanel from '@/components/shared/PdfPreviewPanel.vue'

defineProps({
  title: {
    type: String,
    required: true,
  },
  source: {
    type: [Object, String],
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['cancel'])
</script>
<template>
  <q-card class="dialog-card-flex">
    <navigate-back :text="title" @cancel="emit('cancel')">
      <template v-if="$slots.right" #right>
        <slot name="right" />
      </template>
    </navigate-back>
    <q-card-section class="col q-pa-none">
      <pdf-preview-panel :source="source" :loading="loading" />
    </q-card-section>
  </q-card>
</template>
